// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const FoodSelenium  = {
  productCode: "SBOVZ-SMC",
  productName: "Food Selenium",
  ingredients: "Sunflower de-oiled seed kernel cake",
  overview:"Orgavitaz-Selenium is standardized for Natural Selenium as organically bound natural form from sunflower de-oiled seed kernel cake.",
  assay:" Natural Selenium 0.5 %",
  coNutrients:" Incidental nutrients include natural dietary fiber, zinc, and magnesium (not a claim). ",
  studies:"Comprehensive Stability studies, Cell-assays for analysing traditional forms, better bioavailability and absorption profile of natural Selenium supplementation. ",
  benefits:"Selenium is required to produce thyroid hormone, called tetraiodothyronine or T4 and for conversion to the more active form of the hormone, called triiodothyronine or T3. Helps reduce the risk of autoimmune thyroid disease. Selenium plays a role glutathione synthesis and eventual detoxification in the liver and heavy metal detoxification. Selenium supplementation has antiviral effects, essential for successful male and female reproduction, and e. Higher selenium status seem to lower the risk of prostate, lung, colorectal, and bladder cancers.",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/FoodSelenium/Selenium-1.png",
        "images/Portfolio/OrgavitazForDeficiencies/FoodSelenium/Selenium-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/FoodSelenium/Selenium-3.png",



  ],
  certificates: [
   "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default FoodSelenium ;
